import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import moment from "moment";
import { firstLetterShouldCapital,formatDateMoment } from "../../../utils/utils";
import { selectCurrentCycle } from "../../slices/common";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

const ManufacturingLabelPrint = React.forwardRef(({ printData }, ref) => {
  const {
    printPatientInfo,
   printCount = 1,
    // printSingleBag,
    patientMedicalInfo = {},
  } = printData || {};
  const currentCycle = useSelector(selectCurrentCycle)

  const patientInfo = printPatientInfo?.patient_information || {};
  const batchInfo = printPatientInfo || {};
  const patientName = patientInfo.name || "";
  const qrValue = `${window.location.origin}/lsm/qr/${currentCycle?.qr_code_generation_id}`;
  const date = (d) => (d ? moment(d).format("DD/MM/YYYY") : "-");
   const topLevel =  batchInfo?.patient_information?.print_details?.find((it) => it?.label_type == '6')
   const LeftLogo = topLevel?.brand_logo;
   const RightLogo = topLevel?.org_logo;
   const brand_name = topLevel?.brand_name;
   //const brand_name = topLevel?.brand_name;
   //const org_name = topLevel?.brand_name;
  return (
    <div ref={ref} className="font-sans">
      {Array.from({ length: printCount }).map((_, index) => {

        return (
          <div
            key={index}
            style={{
              width: "11cm",
              height: "11cm",
              border: "1px solid #000",
              padding: "5px",
              boxSizing: "border-box",
              pageBreakAfter: "always",
              fontSize: "8px",
              display: "flex",
              flexDirection: "column",
              borderRadius:"5px"
            }}
          >
            {/* =================== HEADER ====================== */}
            <div className="flex justify-between items-start">
              {/* Left side */}
              <div>
                <p className="text-lg font-bold">
                  {batchInfo.product_name || "Product Name"}
                </p>
                <p className="text-[0.75rem] mt-0.2">
                  {batchInfo.product_description || "Product Description"}
                </p>
              </div>
              {/* Right side → Brand + Logo */}
              <div className="flex flex-col items-end">
                <p className="font-semibold text-sm">{brand_name}</p>
                <img src={LeftLogo} style={{maxHeight:'50px', maxWidth:'100px'}} alt="brand-logo" />
              </div>
            </div>

            {/* Thin line */}
            <div className="border-t border-black my-2" />

            {/* =============== BLACK HEADER BOX WITH HAZARD LOGO =============== */}
            <div className="flex justify-between items-center mb-1 relative">
              <div
                style={{
                  height: "30px",
                  width: "80%",
                  background: "#111111",
                }}
              ></div>

              <img
                src={RightLogo}
                 style={{maxHeight:'50px', maxWidth:'100px'}}
                alt="hazard-logo"
                className="absolute right-[6px] top-[1px]"
              />
            </div>

            {/* ================= DOSAGE BLOCK ================= */}
            <div className="text-[0.5rem] leading-tight">
              <p>
                <strong>Dosage Details:</strong> {batchInfo.dosage_details || "-"}
              </p>
              <p>
                <strong>Composition of the product:</strong>{" "}
                {batchInfo.composition || "-"}
              </p>
              <p>
                <strong>Additional information (If any):</strong>{" "}
                {batchInfo.additional_info || "-"}
              </p>
            </div>

            {/* ================= OUTLINED BOX (LEFT INFO + QR) ================= */}
            <Box
              sx={{
                border: "1px solid #000",
                padding: "5px",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "3px",
              }}
            >
              {/* Left Column */}
              <div className="text-[0.6rem] leading-relaxed space-y-0.1">
                <p>
                  <strong>Patient ID:</strong> {patientInfo.patient_id || "-"}
                </p>
                <p>
                  <strong>Patient Initial:</strong>{" "}
                  {firstLetterShouldCapital(patientName)}
                </p>
                <p>
                  <strong>Patient DOB:</strong>{" "}
                  {patientMedicalInfo["Date of Birth"] || date(patientInfo.dob)}
                </p>
                <p>
                  <strong>Manufacturing Date:</strong>{" "}
                  {formatDateMoment(currentCycle?.mfg_at) || ""}
                </p>
                <p>
                  <strong>Expiry Date:</strong> {date(batchInfo.expiry_date)}
                </p>
                <p>
                  <strong>Batch Number:</strong> {currentCycle?.batch_no || ""}
                </p>
                 <p>
                  <strong>Shipping details:</strong>{" "}
                  {patientMedicalInfo["Ship & Store"] || "2–8 degree celsius"}
                </p>
              </div>

              {/* Right Column → QR */}
              <div className="flex flex-col items-center justify-between">
                <QRCodeCanvas value={qrValue} size={60} />
              </div>
            </Box>

            {/* ================= BOTTOM SECTION ================= */}
            <div className="flex justify-between mt-1 gap-4">
              {/* Dispensing Left */}
              <div className="text-[0.60rem] leading-tight w-1/2">
                <p className="font-bold">Dispensing details</p>
                <p>Dos and don&apos;ts for product: As per SOP / IFU.</p>
                <p>
                  Product evaluation details: Quality checked & released.
                </p>
                <p>Instructions for infusion: Follow prescribing information.</p>
                <p>
                  Thawing and freezing details: Thaw as per product
                  information sheet.
                </p>
              </div>

              {/* Manufacturer Right */}
              <div className="text-[0.60rem] leading-tight w-1/2 text-right">
                <p className="font-bold">Manufacturer details</p>
                <p>{batchInfo.manufacturer_name || "ImmunoACT"}</p>
                <p>Manufacturing Site Address</p>
                <p>{batchInfo.manufacturer_address || "Rabale, Navi Mumbai - 400 701"}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
});

ManufacturingLabelPrint.displayName = "ManufacturingLabelPrint";

export default ManufacturingLabelPrint;
